/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentGroup } from './DocumentGroup';
import {
    DocumentGroupFromJSON,
    DocumentGroupFromJSONTyped,
    DocumentGroupToJSON,
    DocumentGroupToJSONTyped,
} from './DocumentGroup';

/**
 * 
 * @export
 * @interface CreateCaseNoteFromDocumentRequest
 */
export interface CreateCaseNoteFromDocumentRequest {
    /**
     * 
     * @type {DocumentGroup}
     * @memberof CreateCaseNoteFromDocumentRequest
     */
    source: DocumentGroup;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteFromDocumentRequest
     */
    fileId: string;
    /**
     * 
     * @type {string}
     * @memberof CreateCaseNoteFromDocumentRequest
     */
    originTimeZoneId: string;
}



/**
 * Check if a given object implements the CreateCaseNoteFromDocumentRequest interface.
 */
export function instanceOfCreateCaseNoteFromDocumentRequest(value: object): value is CreateCaseNoteFromDocumentRequest {
    if (!('source' in value) || value['source'] === undefined) return false;
    if (!('fileId' in value) || value['fileId'] === undefined) return false;
    if (!('originTimeZoneId' in value) || value['originTimeZoneId'] === undefined) return false;
    return true;
}

export function CreateCaseNoteFromDocumentRequestFromJSON(json: any): CreateCaseNoteFromDocumentRequest {
    return CreateCaseNoteFromDocumentRequestFromJSONTyped(json, false);
}

export function CreateCaseNoteFromDocumentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateCaseNoteFromDocumentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'source': DocumentGroupFromJSON(json['source']),
        'fileId': json['fileId'],
        'originTimeZoneId': json['originTimeZoneId'],
    };
}

export function CreateCaseNoteFromDocumentRequestToJSON(json: any): CreateCaseNoteFromDocumentRequest {
    return CreateCaseNoteFromDocumentRequestToJSONTyped(json, false);
}

export function CreateCaseNoteFromDocumentRequestToJSONTyped(value?: CreateCaseNoteFromDocumentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'source': DocumentGroupToJSON(value['source']),
        'fileId': value['fileId'],
        'originTimeZoneId': value['originTimeZoneId'],
    };
}

